import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ChevronArrowRight from "assets/icons/chevron-arrow-right.svg?react";
import useWesternDisciplines from "hooks/useWesternDisciplines";
import { useBrandDisciplineStore } from "stores/brandDiscipline/useBrandDisciplineStore";

const MegaMenu = ({ onOptionClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { mapDisciplineValue } = useWesternDisciplines();
  const setSelectedDiscipline = useBrandDisciplineStore((action) => action.setSelectedDiscipline);

  const handleSelectDiscipline = (disciplineValue) => {
    const newDiscipline = mapDisciplineValue(disciplineValue);
    setSelectedDiscipline(newDiscipline ? [newDiscipline] : []);

    const searchParams = new URLSearchParams(location.search);
    searchParams.set("discipline", disciplineValue);
    const targetUrl = `/buy?${searchParams.toString()}`;

    navigate(targetUrl, { replace: true });
  };

  const handleSelectBrand = () => {
    // setSelectedBrandName({ label, value });

    // const currentUrl = location.pathname;
    // const targetUrl = horseId ? `/buy?horse=${horseId}` : "/buy";

    // if (currentUrl !== targetUrl) {
    navigate("/cactus");
    // }
  };

  const menuData = [
    {
      title: "DISCIPLINE",
      items: [
        {
          label: "Barrel Racing",
          value: "barrel_racing",
          onClick: (_, value) => {
            handleSelectDiscipline(value);
          },
        },
        {
          label: "Cutting",
          value: "cutting",
          onClick: (_, value) => {
            handleSelectDiscipline(value);
          },
        },
        {
          label: "Ranch Riding",
          value: "ranch_riding",
          onClick: (_, value) => {
            handleSelectDiscipline(value);
          },
        },
        {
          label: "Reining",
          value: "reining",
          onClick: (_, value) => {
            handleSelectDiscipline(value);
          },
        },
        {
          label: "Roping",
          value: "roping",
          onClick: (_, value) => {
            handleSelectDiscipline(value);
          },
        },
        {
          label: "Team Penning Sorting",
          value: "team_penning_sorting",
          onClick: (_, value) => {
            handleSelectDiscipline(value);
          },
        },
        {
          label: "Trail Riding",
          value: "trail_riding",
          onClick: (_, value) => {
            handleSelectDiscipline(value);
          },
        },
        {
          label: "Endurance",
          value: "western_endurance_riding",
          onClick: (_, value) => {
            handleSelectDiscipline(value);
          },
        },
        {
          label: "Western Pleasure",
          value: "western_pleasure",
          onClick: (_, value) => {
            handleSelectDiscipline(value);
          },
        },
      ],
    },
    {
      title: "BRANDS",
      items: [
        {
          label: "Cactus",
          value: "cactussaddlery",
          onClick: () => {
            handleSelectBrand();
          },
        },
        {
          label: "Billy Cook",
          value: "billycook",
          onClick: () => navigate("/billy-cook"),
        },
      ],
    },
  ];

  return (
    <nav className="bg-[rgba(43,54,75,0.80)] min-h-[300px] text-white shadow-[-6px_21px_64px_0px_rgba(0,0,0,0.32)] backdrop-blur-[26.75px] p-6 lg:px-0 lg:py-10">
      <div className="flex items-center justify-center">
        <div className="w-full max-w-[900px] grid grid-cols-1 lg:grid-cols-2 gap-y-4 lg:gap-x-10">
          {menuData.map((section) => (
            <div key={section.title} className="text-center lg:text-left p-4">
              <h2 className="text-white font-barlowCondensed text-xl font-bold leading-[110%] uppercase pb-2 border-b border-[rgba(255,255,255,0.24)]">
                {section.title}
              </h2>
              <ul>
                {section.items.map((item, index) => (
                  <li
                    key={item.label}
                    className={
                      index !== section.items.length - 1
                        ? "border-b border-[rgba(255,255,255,0.24)]"
                        : ""
                    }
                  >
                    <NavLink
                      onClick={(e) => {
                        e.preventDefault();
                        item?.onClick(item.label, item.value);
                        onOptionClick();
                      }}
                      className="group flex items-center justify-center lg:justify-between py-2 text-white font-[Montserrat] text-sm font-normal leading-[120%] transition-colors hover:text-gray-300"
                    >
                      <span>{item.label}</span>
                      <ChevronArrowRight className="absolute right-4 lg:static hidden lg:block" />
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default MegaMenu;
